<template>
    <div v-permission="['superadministrador', 'administrador']" class="container mx-auto px-4 py-6 flex flex-wrap justify-center gap-4">
      <!-- Formulario de creación de usuario -->
      <div class="bg-white p-6 rounded-lg shadow-lg w-full md:max-w-md md:flex-1 md:min-h-[500px]">
        <p class="text-2xl font-bold mb-5">Crear cuenta en el grupo</p>
        <form @submit.prevent="handleRegister" class="flex flex-col gap-4">
          <div v-if="!emailExists">
            <label class="font-medium text-gray-700">Nombre</label>
            <input
              v-model="nombre"
              type="text"
              placeholder="Nombre y apellido"
              class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
              required
            />
          </div>
          <div>
            <label class="font-medium text-gray-700">Dirección de email</label>
            <input
              v-model="email"
              type="email"
              @input="debouncedCheckEmail"
              :class="emailClass"
              class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
              required
            />
            <p v-if="emailExists" class="mt-5 text-green-700 text-sm">
              Este usuario ya existe, solo con el correo podrás asignar este usuario a este grupo.
            </p>
          </div>
          <div v-if="!emailExists">
            <div>
              <label class="font-medium text-gray-700">Contraseña</label>
              <input
                v-model="password"
                type="password"
                placeholder="Debe tener al menos 7 caracteres"
                :class="passwordClass"
                class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
                required
              />
            </div>
            <div class="mt-3">
              <label class="font-medium text-gray-700">Confirmar contraseña</label>
              <input
                v-model="confirmPassword"
                type="password"
                :class="passwordClass"
                class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
                required
              />
            </div>
            <div class="mt-3">
              <label class="font-medium text-gray-700">Rol</label>
              <select
                v-model="role"
                class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
                required
                >
                <option value="">-- Selecciona un rol --</option>
                <option
                    v-permission="['superadministrador']"
                    value="superadministrador"
                >
                    Superadministrador
                </option>
                <option
                    v-permission="['superadministrador', 'administrador']"
                    value="administrador"
                >
                    Administrador
                </option>
                <option
                    v-permission="['superadministrador', 'administrador']"
                    value="usuario"
                >
                    Usuario
                </option>
            </select>

            </div>
          </div>
          <button type="submit" class="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            Crear usuario
          </button>
        </form>
      </div>
  
      <!-- Formulario de creación de link -->
      <div class="bg-white p-6 rounded-lg shadow-lg w-full md:max-w-md md:flex-1 md:min-h-[500px]">
        <p class="text-2xl font-bold mb-5">Crear link de registro</p>
        <form @submit.prevent="handleCreateKey" class="flex flex-col gap-4">
          <div>
            <label class="font-medium text-gray-700">Rol</label>
            <select
              v-model="selectedRoleKey"
              required
              class="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            >
              <option value="">-- Selecciona un rol --</option>
           
                <option
                    v-permission="['superadministrador']"
                    value="superadministrador"
                >
                    Superadministrador
                </option>
                <option
                    v-permission="['superadministrador', 'administrador']"
                    value="administrador"
                >
                    Administrador
                </option>
                <option
                    v-permission="['superadministrador', 'administrador']"
                    value="usuario"
                >
                    Usuario
                </option>
             

            </select>
          </div>
          <button type="submit" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            Generar clave
          </button>
        </form>
        <table v-if="keys.length > 0" class="min-w-full divide-y divide-gray-300">
          <thead>
            <tr class="bg-gray-200">
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Clave</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Permiso</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="key in keys" :key="key.id_token_clave">
              <td class="px-6 py-4 whitespace-nowrap">
                <a
                  :href="`https://sponsor.bmotik.work/registrarse/${key.id_token_clave}`"
                  target="_blank"
                  class="text-blue-500 hover:text-blue-700"
                >
                  {{ key.id_token_clave }}
                </a>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">{{ key.rol }}</td>
              <td class="px-6 py-4 whitespace-nowrap">
                <button @click="deleteKey(key.id_token_clave)" class="text-red-500 hover:text-red-700">
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else class="text-center">No hay claves generadas.</p>
      </div>
  
      <!-- Botón para volver -->
      <div class="mt-6 w-full text-center">
        <button @click="goBack" class="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">
          Volver
        </button>
      </div>
      <ModalConfirm :visible="modalVisible" @close="closeModal" :link="link">
        Este link ha sido enviado por correo al usuario.
      </ModalConfirm>
    </div>
    <!-- <p v-else class="text-red-500 text-center mt-6">No tienes permisos para acceder a esta página.</p> -->
  </template>
  
  <script>
  import axios from "axios";
  import ModalConfirm from "@/components/modal/ModalConfirm.vue";
  import { debounce } from "lodash";
  import { useToast } from "vue-toastification";
  
  export default {
    setup() {
      const toast = useToast();
      return { toast };
    },
    props: ["groupId"],
    data() {
      return {
        nombre: "",
        email: "",
        password: "",
        confirmPassword: "",
        role: "",
        availableRoles: [],
        keys: [],
        selectedRoleKey: "",
        emailExists: false,
        modalVisible: false,
        link: "",
        debouncedCheckEmail: null,
      };
    },
    components: {
      ModalConfirm,
    },
    computed: {
      /**
       * Rol desencriptado almacenado en el estado Vuex.
       */
      currentRole() {
        return this.$store.state.role;
      },
    },
    created() {
      
      this.fetchKeys();
      this.debouncedCheckEmail = debounce(this.checkEmail, 500);
    },
    methods: {
      
      /**
       * Maneja el registro de un nuevo usuario.
       */
      handleRegister() {
        if (!this.validateEmail(this.email)) {
          this.toast.warning("Introduce una dirección de correo válida.");
          return;
        }
        if (!this.emailExists && (this.password.length < 7 || this.password !== this.confirmPassword)) {
          this.toast.error("Verifica que las contraseñas sean correctas y de al menos 7 caracteres.");
          return;
        }
        const data = {
          nombre: this.emailExists ? "Usuario Existente" : this.nombre,
          email: this.email,
          password: this.emailExists ? "xxxxxxxx" : this.password,
          groupId: this.groupId,
          role: this.role,
        };
        axios
          .post("/api/register", data)
          .then((response) => {
            this.modalVisible = true;
            this.link = response.data.link;
            this.toast.success("Usuario creado exitosamente.");
            this.clearForm();
          })
          .catch(() => {
            this.toast.error("Error al crear el usuario.");
          });
      },
      /**
       * Limpia los datos del formulario.
       */
      clearForm() {
        this.nombre = "";
        this.email = "";
        this.password = "";
        this.confirmPassword = "";
        this.role = "";
      },
      /**
       * Verifica si el correo ya existe.
       */
      checkEmail() {
        if (this.validateEmail(this.email)) {
          axios
            .post("/api/check-mail/validate", { email: this.email })
            .then((response) => {
              this.emailExists = response.data.valid === 0;
            })
            .catch(() => {
              this.toast.error("Error al verificar el correo.");
            });
        } else {
          this.toast.warning("Introduce un correo válido.");
        }
      },
      /**
       * Maneja la creación de una clave de registro.
       */
    //   handleCreateKey() {
    //     axios
    //       .post("/api/create-key", {
    //         groupId: this.groupId,
    //         role: this.selectedRoleKey,
    //       })
    //       .then((response) => {
    //         if (response.data.success) {
    //           this.toast.success("Clave generada exitosamente.");
    //           this.keys.push(response.data.key);
    //         } else {
    //           this.toast.error("Error al generar la clave.");
    //         }
    //       })
    //       .catch(() => {
    //         this.toast.error("Error al generar la clave.");
    //       });
    //   },
    handleCreateKey() {
  axios
    .post(
      '/api/create-key',
      {
        groupId: this.groupId || null, // Si no hay grupo, enviar null
        role: this.selectedRoleKey,
        regions: this.regions || null, // Opcional según tu caso
      },
      {
        headers: {
          'X-User-Role': this.$store.state.role, // Rol actual del usuario
          'X-User-Token': this.$store.state.token, // Token actual del usuario
        },
      }
    )
    .then((response) => {
        if (response.data.success) {
            this.toast.success("Clave generada exitosamente.");
            this.keys.push(response.data.key);
        } else {
            this.toast.error("Error al generar la clave.");
        }
        })
        .catch((error) => {
        if (error.response?.status === 403) {
            this.toast.error("No tienes permiso para realizar esta acción.");
        } else {
            this.toast.error("Error al generar la clave.");
        }
        });
    },

      /**
       * Obtiene las claves de registro del grupo.
       */
       fetchKeys() {
        axios
            .get(`/api/keys/${this.groupId || ''}`, {
            headers: {
                'X-User-Role': this.$store.state.role, // Rol actual del usuario
                'X-User-Token': this.$store.state.token, // Token actual del usuario
            },
            })
            .then((response) => {
            this.keys = response.data.keys || [];
            })
            .catch((error) => {
            if (error.response?.status === 403) {
                this.toast.error("No tienes permiso para realizar esta acción.");
            } else {
                this.toast.error("Error al cargar las claves.");
            }
            });
        },

      /**
       * Elimina una clave de registro.
       * @param {string} token - Token de la clave a eliminar.
       */
      deleteKey(token) {
        axios
          .post("/api/delete-key", { token })
          .then((response) => {
            if (response.data.success) {
              this.keys = this.keys.filter((key) => key.id_token_clave !== token);
              this.toast.success("Clave eliminada exitosamente.");
            } else {
              this.toast.error("Error al eliminar la clave.");
            }
          })
          .catch(() => {
            this.toast.error("Error al eliminar la clave.");
          });
      },
      /**
       * Valida si un correo es válido.
       * @param {string} email - Correo a validar.
       * @returns {boolean} - Indica si el correo es válido.
       */
      validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      },
    },
  };
  </script>
  

<style lang="scss" scoped>
.flex-wrap {
  display: flex;
  flex-direction: row;
}
</style>
